import { useCallback, useState } from "react";
import { GeoError, GeoResult, detectCity } from "@/features/geo";

type Status = "idle" | "busy" | "ready" | "error";

/** Одна кнопка «Определить по геопозиции» — одно состояние на шторку и онбординг. */
export function useGeoCity() {
  const [status, setStatus] = useState<Status>("idle");
  const [result, setResult] = useState<GeoResult | null>(null);
  const [error, setError] = useState<string | null>(null);

  const detect = useCallback(async (): Promise<GeoResult | null> => {
    setStatus("busy");
    setError(null);
    try {
      const r = await detectCity();
      setResult(r);
      setStatus("ready");
      return r;
    } catch (e) {
      setError(e instanceof GeoError ? e.message : "Не удалось определить позицию");
      setStatus("error");
      return null;
    }
  }, []);

  return { status, result, error, detect };
}
